var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(!_vm.$route.meta.public)?[_c(_vm.layout,{tag:"component"})]:[_c('sequential-entrance',[_c('router-view')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }